
import { Vue } from 'vue-class-component';
import { ElMessage, ElMessageBox } from 'element-plus';
import ServiceCodeService from '@/services/serviceCodeService';
import * as countryAreaCode from '@/assets/data/countryAreaCode.json';
import RoleService from '@/services/roleService';
import AccountType from '@/constants/AccountType';
import router from '@/router';
import ErrorCode from '@/constants/ErrorCode';
import UserInfoService from '@/services/userInfoService';
import CustomerService from '../services/customerService';
import CreateCustomerModel from '../models/createCustomerModel';
import CurrentUserService from '../services/currentUserService';
import CurrentUserModel from '../models/userInfos/currentUserModel';
import CommonValidate from '../services/commonValidate';

export default class Customer extends Vue {
    private customerList = [];

    private userInfo: CurrentUserModel = CurrentUserService.GetUserInfo();

    private countryAreaCodes = (countryAreaCode as any).default;

    private dialogVisible = false;

    private resources = [];

    private accessGroups = [];

    private nameError = '';

    private name = '';

    private page = 1;

    private size = 10;

    private total = 0;

    private createCustomer = new CreateCustomerModel();

    get accessGroup(): any {
        return this.accessGroups.filter(
            (it: any) => it.accountType === AccountType.CustomerAccount
        );
    }

    private rules = {
        code: [
            {
                required: true,
                whitespace: true,
                message: '请输入客户编码',
                trigger: 'blur',
            },
            { len: 5, message: '长度为5个字符', trigger: 'blur' },
            { validator: CommonValidate.validateNumAndLetter, trigger: 'blur' },
        ],
        name: [
            {
                required: true,
                whitespace: true,
                message: '请输入客户名',
                trigger: 'blur',
            },
            { validator: CommonValidate.validateCustomerName, trigger: 'blur' },
        ],
        userAccount: [
            { required: true, message: '请输入客户账号', trigger: 'blur' },
            {
                min: 5,
                max: 10,
                message: '长度在 5 到 10 个字符',
                trigger: 'blur',
            },
            { validator: CommonValidate.validateNumAndLetter, trigger: 'blur' },
        ],
        phoneNo: [
            {
                required: true,
                whitespace: true,
                message: '请输入手机号码',
                trigger: 'blur',
            },
            { validator: CommonValidate.validatePhone, trigger: 'blur' },
        ],
        serviceCode: [
            { required: true, message: '请选择地区资源', trigger: 'change' },
        ],
        accessGroupId: [
            { required: true, message: '请选择角色', trigger: 'change' },
        ],
    };

    async loadRole(): Promise<void> {
        RoleService.getAll()
            .then((result) => {
                if (result.code === ErrorCode.Success) {
                    this.accessGroups = result.data;
                }
            })
            .catch((response) => {
                console.log(response);
            });
    }

    async loadResource(): Promise<void> {
        ServiceCodeService.getAll()
            .then((result) => {
                if (result.code === ErrorCode.Success) {
                    this.resources = result.data;
                }
            })
            .catch((response) => {
                console.log(response);
            });
    }

    mounted(): void {
        this.loadData();
        this.loadResource();
        this.loadRole();
    }

    loadData(): void {
        CustomerService.getAll(this.page, this.size, this.name)
            .then((result) => {
                if (result.code === ErrorCode.Success) {
                    this.customerList = result.data.data;
                    this.total = result.data.total;
                } else {
                    ElMessage.error(result.msg);
                }
            })
            .catch((response) => {
                console.log(response);
                ElMessage.error(response.msg);
            });
    }

    pageChange(currentPage: number): void {
        this.page = currentPage;
        this.loadData();
    }

    saveCustomer(): void {
        const form: any = this.$refs.createform;
        form.validate((valid: boolean) => {
            if (valid) {
                CustomerService.create(this.createCustomer)
                    .then((response) => {
                        if (response.code === ErrorCode.Success) {
                            ElMessage.success(response.msg);
                            this.dialogVisible = false;
                            this.loadData();
                            form.resetFields();
                        } else if (
                            response.code === ErrorCode.ParamsterInvalid
                        ) {
                            ElMessage.error(response.msg);
                            this.showError(response.data);
                        } else {
                            ElMessage.error(response.msg);
                        }
                    })
                    .catch((err) => {
                        if (err && err.msg) {
                            ElMessage.error(err.msg);
                        } else {
                            ElMessage.error('操作失败');
                        }
                    });
            }
        });
    }

    showError(errors: any): void {
        errors.forEach((element: any) => {
            if ((element.field as string).toLowerCase() === 'name') {
                this.nameError = element.message;
            }
        });
    }

    opendetail(id: string): void {
        router.push({ path: `/customer/${id}` });
    }

    reSetPass(id: string): void {
        ElMessageBox.confirm('你确定要重置此账号密码', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        }).then(() => {
            UserInfoService.resetPassword(id)
                .then((response) => {
                    if (response.code === ErrorCode.Success) {
                        ElMessage.success(response.msg);
                    } else {
                        ElMessage.error(response.msg);
                    }
                })
                .catch(() => {
                    ElMessage.error('操作失败');
                });
        });
    }

    del(id: string, name: string): void {
        const msg = `你确定要删除【${name}】客户?`;
        ElMessageBox.confirm(msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        }).then(() => {
            CustomerService.delete(id)
                .then((response) => {
                    if (response.code === ErrorCode.Success) {
                        ElMessage.success(response.msg);
                        this.loadData();
                    } else {
                        ElMessage.error(response.msg);
                    }
                })
                .catch(() => {
                    ElMessage.error('操作失败');
                });
        });
    }
}
